<template>
  <bscroll-view>
    <div class="introduce">
      <div class="banner_">
        <div class="bannerBg">
          <img src="@/assets/introduce/bannerBG.png" />
        </div>
        <div class="bannerWapCon">
          <div class="bannerWap">
            <div class="text">
              <div>人文大众精品阅览室</div>
              <div>文档实时协同 · 知识沉淀管理 · 数据安全可控</div>
              <div>开始使用</div>
            </div>
            <div class="img_">
              <img src="@/assets/introduce/bannerBG2.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div class="viewOneWap">
        <div class="title">多种资源的「精品阅览室」</div>
        <div class="content">
          <img src="@/assets/introduce/content1.png" alt="" />
        </div>
      </div>
      <div class="viewTwoWap">
        <div class="icons">
          <div class="items" v-for="(item, index) in iconslist" :key="index">
            <div class="img_">
              <img :src="item.img" alt="" />
            </div>
            <div class="txt_">
              <div>{{ item.txt1 }}</div>
              <div>{{ item.txt2 }}</div>
            </div>
          </div>
        </div>
        <div class="txt_">
          “龙源人文大众精品阅览室”是根据国家《公共图书馆法》、《国家基本公
          共服务体系“十二五”规划》等重要法规的要求专门为公共图书馆打造的新一
          代数字阅览室。为大众提供人文、大众精品内容，其先进的功能和用户体验将
          方便地提升馆内关外服务的质量，将以数字化的远程方式为县级、基层文化社
          区提供高品质的标准产品并且和馆方合作为个人提供增值服务，形成完善的公
          共文化服务网络。龙源人文大众精品阅览室主要由人文期刊、必读图书、特色
          音视频课程组成的阅览室和根据知识体系和知识图谱建设的主题知识库、学科
          知识库和职业知识库。
          建设了党建、普法、科普、国学、职工书屋、农家书屋等系列。
        </div>
      </div>

      <div class="viewThreeWapTwo">
        <div class="txt_">
          <div>精品期刊阅览室</div>
          <div>
            自1998年成立以来，龙源形成了人文大众类期刊的精品特色，被中宣部确定为人文
            大众期刊的权威平台，类别涵盖时政新闻、经济法律、管理财经、社科历史、文学文摘、健
            康生活、文化艺术、科技科普、教育教学等多个领域，正版授权实时更新。
          </div>
        </div>
        <div class="img_">
          <img src="@/assets/introduce/content3.png" alt="" />
        </div>
      </div>

      <div class="viewThreeWap">
        <div class="img_">
          <img src="@/assets/introduce/content4.png" alt="" />
        </div>
        <div class="txt_">
          <div>分众阅览室</div>
          <div>
            在专家团队指导下，通过专业编辑团队和⼈人⼯工智能技术
            对内容按照职业类型进⾏行行了了精准化内容分类，分众化阅读服
            务让读者阅读更更具有针对性。<br />
            <br />通过垂直化内容细分让每个读
            者均能找到与其职业相匹配的阅读内容，如教师必读、公务
            员必读、律律师必读、医⽣生必读等。
          </div>
        </div>
      </div>

      <div class="viewFourWap">
        <div class="items">
          <div>职业知识库</div>
          <div>
            主题知识库可根据不不同⽤用户 的阅读轨迹和兴趣定制提供
            智能化的阅读服务，涵盖哲 学、历史、教育、经济、⼼心
            理理、⽂文学等维度，以正式出 版的书刊杂志内容、得到社
            会认可的专家学者论⽂文、新 媒体等为内容依据，将知识
            结构结合⼤大众通识认识重新 组织。
          </div>
        </div>
        <div class="items">
          <div>学科知识库</div>
          <div>
            职业知识库可根据不不同⽤用户 的⼯工作内容和兴趣定制提供
            智能化的阅读服务，涵盖医 ⽣生、职员、教师、学⽣生、律律
            师、公务员等维度，根据不不 同职业的特点和需求把知识
            内容按照社会职业重新组 织，以正式出版的书刊杂志
            内容、得到社会认可的专家 学者论⽂文、新媒体等为内容
            依据，是⻰龙源向⼤大众提供知 识服务⾸首创⽽而且最有特⾊色的
            产品形式。
          </div>
        </div>
        <div class="items">
          <div>主题知识库</div>
          <div>
            ⼈文学科知识库可根据不不同 ⽤用户的学习轨迹和兴趣定制
            提供智能化的阅读服务，涵 盖哲学、历史、教育、经、
            ⼼心理理、⽂文学等维度，以正式 出版的书刊杂志内容、得到
            社会认可的专家学者论⽂文、 新媒体等为内容依据，将知
            识结构结合⼤大众通识认识重 新组织。
          </div>
        </div>
      </div>

      <div class="viewFiveWap">
        <img src="@/assets/introduce/content5.png" alt="" />
      </div>

      <div class="viewThreeWapTwo">
        <div class="txt_">
          <div>个人阅览室</div>
          <div>
            关注内容的更新提醒，通过“关注”平台任何内容，都可以在内容获得更新时，获得最新的提醒。<br />提供每个读者自己的阅读空间，收藏和沉淀自己发现的好内容
          </div>
        </div>
        <div class="img_">
          <img src="@/assets/introduce/content6.png" alt="" />
        </div>
      </div>

      <div class="viewThreeWap">
        <div class="img_">
          <img src="@/assets/introduce/content7.png" alt="" />
        </div>
        <div class="txt_">
          <div>智能首页</div>
          <div>
            每个图书馆的服务侧重不同，结合各阅览室、知识库。内容被智能组合，形成图书馆个性化的阅读推荐比例。<br /><br />图书馆可以根据每一阶段的服务重点，突出服务权重，如在建党100周年之际加大“党政阅览室”，“党政知识库”，党报、党刊的首页推荐比例。
          </div>
        </div>
      </div>

      <div class="viewSixWap">
        <div>多平台服务，实现通用终端全覆盖</div>
        <div>
          全面覆盖电脑、移动设备等多个终端，毫秒级实时同步内容，满足企业成员各场景文化服务诉求
        </div>
        <div>
          <img src="@/assets/introduce/content8.png" alt="" />
        </div>
      </div>

      <div class="viewSevenWap">
        <div class="left_">
          <img src="@/assets/introduce/content9.png" alt="" />
        </div>
        <div class="right_">
          <div>龙源人文大众精品阅览室</div>
          <div>
            是根据国家《公共图书馆法》《国家基本公共服务体系“⼗十⼆二五”规划》等重要法
            规的要求专⻔门为公共图书馆打造的新⼀一代数字阅览室。公共图书馆的服务对象是
            城市的所有居⺠民，担负着为⼤大众提供⼈人⽂文、⼤大众的公共⽂文化服务。所谓⼈人⽂文，就
            是以提升精神⽂文明和⽂文化素质为⽬目标的思想、历史、法律律、科学、⽂文学、教育、
            艺术等综合内容;所谓⼤大众，就是⼈人⺠民群众⽣生活和⼯工作，⽐比如:健康、家庭、旅
            游、创业等⾐衣⻝⾷食住⾏行行相关的综合内容。所谓精品，就是为了了让使⽤用者能在信息纷
            繁，内容爆炸的时代获得他们最精华的优质内容和通识教育。阅览室根据互联⽹网
            技术所⽀支撑的先进的功能和⽤用户体验将⽅方便便地提升馆内馆外服务的质量量，将以数
            字化的远程⽅方式为县级、基层⽂文化社区提供⾼高品质的标准产品并且和馆⽅方合作提
            供馆内馆外的⽤用户增值服务，形成完善的公共⽂文化服务⽹网络。
          </div>
        </div>
      </div>

      <div class="viewEightWap">
        <div class="title">龙源人文大众精品阅览室建设依据</div>
        <div class="content">
          <div>
            《中华⼈人⺠民共和国公共图书 馆法》第四章第四⼗十条之规
            定:国家构建标准统⼀一、互联 互通的公共图书馆数字服务⽹网
            络，⽀支持数字阅读产品开发和 数字资源保存技术研究，推动
            公共图书馆利利⽤用数字化、⽹网络 化技术向社会公众提供便便捷服
            务。政府设⽴立的公共图书馆应 当加强数字资源建设、配备相
            应的设施设备，建⽴立线上线下 相结合的⽂文献信息共享平台，
            为社会公众提供优质服务。
          </div>
          <div>
            《中华⼈人⺠民共和国公共⽂文化 服务保障法》对于公共⽂文化服
            务提供的分类标准。第三章第 ⼆二⼗十七条规定:各级⼈人⺠民政府
            应当充分利利⽤用公共⽂文化设施， 促进优秀公共⽂文化产品的提供
            和传播，⽀支持开展全⺠民阅读、 全⺠民普法、全⺠民健身、全⺠民科
            普和艺术普及、优秀传统⽂文化 传承活动。
          </div>
          <div>
            第三章第三⼗十条规定:基层 综合性⽂文化服务中心应当加强
            资源整合，建⽴立完善公共⽂文化 服务⽹网络，充分发挥统筹服务
            功能，为公众提供书报阅读、 影视观赏、戏曲表演、普法教
            育、艺术普及、科学普及、⼴播播送、互联⽹上⽹和群众性
            ⽂文化体育活动等公共⽂文化服
            务，并根据其功能特点，因地制宜提供其他公共服务。
          </div>
        </div>
      </div>
      <div class="viewNineWap">
        <div class="title">
          <div></div>
          <span>为20万家知名企业用户提供服务</span>
          <div></div>
        </div>
        <div class="titie2">
          覆盖图书馆、教育、社区、文化馆、职工书屋、党政单位等20多个行业
        </div>
        <div class="img">
          <img src="@/assets/introduce/content10.png" alt="" />
        </div>
      </div>
      <div class="viewTenWap">
        <div class="title">社区图书馆</div>
        <div class="img">
          <img src="@/assets/introduce/content11.png" alt="" />
        </div>
      </div>
      <footer-com />
    </div>
  </bscroll-view>
</template>
<script>
import BscrollView from "@/components/bscrollView";
import FooterCom from "@/components/footerCom/footerCom";

export default {
  name: "introduce",
  components: {
    BscrollView,
    FooterCom,
  },
  data() {
    return {
      iconslist: [
        {
          img: require("@/assets/introduce/content2-1.png"),
          txt1: "人文名刊阅览室",
          txt2: "100种名刊大刊",
        },
        {
          img: require("@/assets/introduce/content2-2.png"),
          txt1: "期刊数据库",
          txt2: "期刊历史数据查询",
        },
        {
          img: require("@/assets/introduce/content2-3.png"),
          txt1: "主题阅览室",
          txt2: "各领域资源汇总",
        },
        {
          img: require("@/assets/introduce/content2-4.png"),
          txt1: "人文知识库",
          txt2: "期刊文章百科大全",
        },
        {
          img: require("@/assets/introduce/content2-5.png"),
          txt1: "知识书",
          txt2: "古今中外经典读物",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.introduce {
  width: 100%;
  .viewTenWap {
    width: 935px;
    margin: 108px auto;
    .img{
      width: 100%;
      img{
        width: 100%;
      }
    }
    .title {
      font-size: 36px;
      font-family: AlibabaPuHuiTiB;
      color: #333333;
      text-align: center;
      margin-bottom: 66px;
    }
  }
  .viewNineWap {
    width: 1200px;
    margin: 96px auto;
    .img {
      width: 935px;
      margin: auto;
      img {
        width: 100%;
      }
    }
    .titie2 {
      font-size: 18px;
      font-family: AlibabaPuHuiTiR;
      color: #909399;
      margin: 12px 0;
      text-align: center;
    }
    .title {
      width: 900px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin: auto;
      div {
        width: 100px;
        height: 4px;
        background: #f0f2f5;
      }
      span {
        font-size: 36px;
        font-family: AlibabaPuHuiTiB;
        color: #333333;
        margin: 0 30px;
      }
    }
  }
  .viewEightWap {
    width: 1200px;
    margin: 96px auto;
    .content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      div {
        width: 380px;
        height: 240px;
        font-size: 18px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        line-height: 24px;
      }
    }
    .title {
      width: 100%;
      font-size: 36px;
      font-family: AlibabaPuHuiTiB;
      color: #303133;
      text-align: center;
      margin-bottom: 60px;
    }
  }
  .viewSevenWap {
    width: 1200px;
    margin: 100px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .right_ {
      width: 480px;
      div:nth-of-type(1) {
        font-size: 36px;
        font-family: AlibabaPuHuiTiB;
        color: #303133;
      }
      div:nth-of-type(2) {
        margin-top: 20px;
        font-size: 18px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        line-height: 24px;
      }
    }
    .left_ {
      width: 717px;
      img {
        width: 100%;
      }
    }
  }
  .viewSixWap {
    width: 1200px;
    margin: 108px auto;
    text-align: center;
    div:nth-of-type(1) {
      font-size: 36px;
      font-family: AlibabaPuHuiTiB;
      color: #333333;
    }
    div:nth-of-type(2) {
      height: 24px;
      font-size: 18px;
      font-family: AlibabaPuHuiTiR;
      color: #909399;
      margin: 12px 0 47px 0;
    }
    div:nth-of-type(3) {
      width: 1025px;
      img {
        width: 100%;
      }
    }
  }
  .viewFiveWap {
    width: 1040px;
    margin: 60px auto;
    img {
      width: 100%;
    }
  }
  .viewFourWap {
    width: 100%;
    margin: 58px 0;
    .items:nth-of-type(1) {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding-right: 5%;
      box-sizing: border-box;
    }
    .items:nth-of-type(2) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .items:nth-of-type(3) {
      display: flex;
      flex-direction: column;
      // align-items: flex-end;
      padding-left: 5%;
      box-sizing: border-box;
    }
    .items {
      width: 100%;
      margin-top: 40px;
      div {
        width: 960px;
      }
      div:nth-of-type(1) {
        font-size: 36px;
        font-family: AlibabaPuHuiTiB;
        color: #303133;
      }
      div:nth-of-type(2) {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #909399;
        line-height: 24px;
        margin-top: 20px;
      }
    }
  }
  .viewThreeWapTwo {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 42px;
    .txt_ {
      width: 27%;
      div:nth-of-type(1) {
        font-size: 36px;
        font-family: AlibabaPuHuiTiB;
        color: #303133;
      }
      div:nth-of-type(2) {
        margin-top: 20px;
        font-size: 18px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        line-height: 24px;
      }
    }
    .img_ {
      width: 66%;
      img {
        width: 100%;
      }
    }
  }
  .viewThreeWap {
    width: 100%;
    display: flex;
    // justify-content: flex-end;
    align-items: center;
    margin-top: 42px;
    .txt_ {
      width: 27%;
      div:nth-of-type(1) {
        font-size: 36px;
        font-family: AlibabaPuHuiTiB;
        color: #303133;
      }
      div:nth-of-type(2) {
        margin-top: 20px;
        font-size: 18px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        line-height: 24px;
      }
    }
    .img_ {
      width: 66%;
      img {
        width: 100%;
      }
    }
  }
  .viewTwoWap {
    width: 1200px;
    margin: auto;
    .txt_ {
      width: 720px;
      font-size: 14px;
      font-family: AlibabaPuHuiTiR;
      color: #909399;
      line-height: 20px;
      margin: 40px auto 0;
    }
    .icons {
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .items {
        width: 240px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .txt_ {
          text-align: center;
          div:nth-of-type(1) {
            margin: 10px 0 4px;
            font-size: 18px;
            font-family: AlibabaPuHuiTiM;
            color: #303133;
          }
          div:nth-of-type(2) {
            font-size: 15px;
            font-family: AlibabaPuHuiTiR;
            color: #909399;
          }
        }
        .img_ {
          width: 80px;
          height: 80px;
          img {
            width: 100%;
          }
        }
      }
    }
  }
  .viewOneWap {
    width: 1200px;
    margin: auto;
    padding: 50px 0;
    box-sizing: border-box;
    text-align: center;
    background: #ffffff;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    position: relative;
    top: -50px;
    .content {
      width: 904px;
      margin: 60px auto 0;
      img {
        width: 100%;
      }
    }
    .title {
      font-size: 36px;
      font-family: AlibabaPuHuiTiB;
      color: #333333;
      text-align: center;
    }
  }
  .banner_ {
    width: 100%;
    height: 900px;
    position: relative;
    // overflow: hidden;
    .bannerBg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .bannerWapCon {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 1;
      .bannerWap {
        width: 100%;
        height: 100%;
        position: relative;
        padding-top: 120px;
        box-sizing: border-box;
        .text {
          div {
            text-align: center;
            width: 100%;
          }
          div:nth-of-type(1) {
            font-size: 80px;
            font-family: AlibabaPuHuiTiB;
            color: #ffffff;
          }
          div:nth-of-type(2) {
            font-size: 24px;
            font-family: AlibabaPuHuiTiR;
            color: #ffffff;
            margin: 20px 0 30px 0;
          }
          div:nth-of-type(3) {
            width: 136px;
            height: 48px;
            background: #ffffff;
            border-radius: 8px;
            line-height: 48px;
            margin: auto;
            cursor: pointer;
          }
        }
        .img_ {
          width: 100%;
          position: absolute;
          bottom: 50px;
          left: 0;
          display: flex;
          justify-content: center;
          img {
            width: 1103px;
            height: 439px;
          }
        }
      }
    }
  }
}
</style>
